import React, { FC, useCallback } from 'react';
import { ContextMenuTrigger } from 'react-contextmenu';
import { ContextMenuId } from '../../../../constants/ContextMenuId';
import { IOuter } from './BoardsContextMenuTrigger.types';

export const BoardsContextMenuTrigger: FC<IOuter> = ({ children, contextMenuRef, clickOrigin }) => {
  const collect = useCallback(() => ({ contextMenuOrigin: clickOrigin }), [clickOrigin]);

  return (
    <ContextMenuTrigger
      renderTag="span"
      id={ContextMenuId.Boards}
      holdToDisplay={-1}
      ref={contextMenuRef}
      collect={collect}
    >
      {children}
    </ContextMenuTrigger>
  );
};
